(function MyTrips($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/MyTrips/myAccount/', '/MyTrips/tripDetails/', '/MyTrips/tripDocuments', '/MyTrips/trips', '/MyTrips/coupns', '/MyTrips/buckets'], function onload()
		{
			var table = $('.nav-arrows').parent().find('table');

			Adzuki.TableArrows(table);

			if (location.hash) {
				loadTabContent(location.hash);
				$("a[href='" + location.hash + "']").tab("show");
			}

			$(document.body).on("click", "a[data-toggle='tab']", function tabToggle(event) {
				var href      = this.getAttribute("href");
				location.hash = href;
				loadTabContent(href);
			});

			$(window).on("popstate", function popstate() {
				var anchor = location.hash || $("a[data-toggle='tab']").first().attr("href");
				loadTabContent(anchor);
				$("a[href='" + anchor + "']").tab("show");
			});

			// Quote insurance
			$('.get-quote').click(onQuoteBtnClick);

			// View Insurance Quote
			$('.view-quote').click(onViewQuoteClick);

			// View Purchased Insurance Policy
			$('.view-policy').click(onViewPolicyClick);

			$('#excursion-reservation').on("change", function changeItin() {
				// used to ajax in the excursions to our page
				// populateExcursions(true);

				var $self = $(this),
				    url   = $self.val();

				// send the user to SEG's site
				if (url.length > 0) {
					window.open(url, '_blank');
				}
			});
		});

		Adzuki.onload('/MyTrips/addProfilePersonalInformation/', function onload()
		{
			Adzuki.Ajax.get('/MyTrips/addProfilePersonalInformation/personal_information')
			.then(function selectIncompleted(response)
			{
				$.each(response, function iterateThroughResponse(key, item)
				{
					// we doing this because of any disabled field that is being load in the form so the  missing-field-error class wont apply to it.
					var $is_disabled = $('#mytripsprofilepersonalinformation-' + item).closest('.form-group input').attr('disabled');

					if (!$is_disabled) {
						$('#mytripsprofilepersonalinformation-' + item).closest('.form-group').addClass('missing-field-error');
					}
				});
			});

			// we dont want to show any value is no_middle_name attribute is set to 1 in the database.
			if ($('#mytripsprofilepersonalinformation-middle_name').is(':disabled')) {
				$('#mytripsprofilepersonalinformation-middle_name').val('');
			}

			$('.no-middle-name-field').on('change', function noMiddleName() {
				var $checkbox = $(this).prop('checked');

				$('#mytripsprofilepersonalinformation-middle_name').prop('disabled', $checkbox);
				$('#mytripsprofilepersonalinformation-middle_name').val('');

				$('#mytripsprofilepersonalinformation-middle_name').closest('.form-group').toggleClass('has-error');
			});
		});

		Adzuki.onload('/MyTrips/index/', function onload()
		{
			var completed   = $('.progress-bar').data('percent');
			var $last_item  = $('.progress-completion-body .progress-completion-body-item').last();
			var $first_item = $('.progress-completion-body .progress-completion-body-item').first();

			$('[data-toggle="popover"]').popover({
				html   : true,
				trigger: "hover",
				content: function content() {
				  var content = $(this).attr("data-popover-content");

				  return $(content).children(".popover-body").html();
				}
			});

			$('.no-loyalty-program-link').on('click', function noLoyaltyProgram(e) {
				e.preventDefault();

				Adzuki.Ajax
				.post(
					Adzuki.base_uri + '/MyTrips/index/',
					{
						no_loyalty_program: 1
					}
				).then(function reloadingPage() {
					window.location.reload();
				});
			});

			$('.message-description-link').on('click', function hideCompletedMessage(e) {
				e.preventDefault();

				$('.profile-completion-box').slideUp();

				Adzuki.Ajax
				.post(
					Adzuki.base_uri + '/MyTrips/index/',
					{
						hide_completed_message: 1
					}
				);
			});

			if (completed === 100) {
				$('.progress-completion-bar-icon').addClass('completed-icon-color');
				$('.progress-completion-message').removeClass('hidden').fadeOut(0).fadeIn(900);
			} else {
				$('.progress-completion-bar-icon').css("background-color", "#e1e9ee");
			}

			$('.next-button').on('click', function moveForwardList() {
				var $active_item = $('.progress-completion-body .progress-completion-body-item.active');
				var $next_item = $active_item.next();

				if ($('.previous-button').hasClass('disabled')) {
					$('.previous-button').removeClass('disabled');
				}

				if ($next_item.length === 0) {
					$('.next-button').addClass('disabled');
				} else {
					$active_item.addClass('hidden');
					$active_item.removeClass('active');
					$next_item.removeClass('hidden').fadeOut(0).fadeIn(900);
					$next_item.addClass('active');

					if ($next_item[0] === $last_item[0]) {
						$('.next-button').addClass('disabled');
					}
				}
			});

			$('.previous-button').on('click', function moveBackList() {
				var $active_item = $('.progress-completion-body .progress-completion-body-item.active');
				var $prev_item = $active_item.prev();

				if ($('.next-button').hasClass('disabled')) {
					$('.next-button').removeClass('disabled');
				}

				if ($prev_item.length === 0) {
					$('.previous-button').addClass('disabled');
				} else {
					$active_item.addClass('hidden');
					$active_item.removeClass('active');
					$prev_item.removeClass('hidden').fadeOut(0).fadeIn(800);
					$prev_item.addClass('active');

					if ($prev_item[0] === $first_item[0]) {
						$('.previous-button').addClass('disabled');
					}
				}
			});
		});

		$('.coupon-image-container').click(function showEnlargedCoupon() {
			var $image_path = $(this).data('img'),
				$title      = $(this).data('title'),
				$modal      = $('.modal'),
				$img        = $('<img />');

			$img.attr('src', Adzuki.base_uri + $image_path);
			$img.attr('alt', $title);
			$img.css('margin', 'auto').css('display', 'block');
			$modal.find('.modal-body').html('');
			$modal.find('.modal-dialog').addClass('modal-lg');
			$img.appendTo($modal.find('.modal-body'));
			$modal.find('.modal-title').text($title);

			$modal.modal();
		});

		$('.interested').click(function showInterestedModal(e) {
			var $item_id = $(this).data('item-id'),
				$modal   = $('.modal');

			e.preventDefault();

			Adzuki.Ajax.get(Adzuki.base_uri + '/MyTrips/interested/' + $item_id).then(function success(response) {
				$modal.find('.modal-body').html(response);
				Adzuki.Form.initAjaxForm('MyTripsBucketInterested');

				$modal.find('.modal-dialog').addClass('modal-lg');
				$modal.find('.modal-title').text('Interested in this bucket item?');

				$modal.modal();
			});
		});

		$('.my-trips-login-modal').click(function showLoginModal(e) {
			var title   = 'myTrips Sign In',
				content = $(".mytrips-login-modal-body").html(),
				$modal  = $('.modal');

			e.preventDefault();

			$modal.find('.modal-title').text(title);
			$modal.find('.modal-body').html('');
			$modal.find('.modal-body').html(content);

			Adzuki.Form.initAjaxForm('MyTripsLogin');

			$modal.modal();
		});
	});

	/**
	 * If tab content needs to be pulled in via ajax
	 * @param  string tab the hash of the tab clicked
	 */
	function loadTabContent(tab)
	{
		if (tab === "#excursions") {
			// populateExcursions();
		}

		if (tab === "#property-info") {
			loadGoogleMap();
		}
	}

	function onQuoteBtnClick(event)
	{
		var reservation_id = $(this).data('reservation-id');
		var url            = '/Reservations/insuranceQuote/' + reservation_id;

		$('.insurance-details').empty();
		$('.quote-loader').removeClass('hidden');

		Adzuki.Ajax.get(url).then(function quoteResponse(response)
		{
			$('.quote-loader').addClass('hidden');
			$('.insurance-details').html(response);
		});
	}

	/**
	 * Pull in shore excursions and place html onto the page. Only load shore excursions via ajax once per full page refresh
	 */
	// function populateExcursions(force_refresh)
	// {
	// 	var $input       = $('#excursion-reservation'),
	// 	    component_id = $input.val(),
	// 	    populated    = $input.data('populated'),
	// 	    $div         = $('#excursions').find('.excursion-content'),
	// 	    ajax_refresh = true,
	// 	    ajax_url     = '/MyTrips/getExcursions/' + component_id;

	// 	if (populated === 1) {
	// 		ajax_refresh = false;
	// 	}

	// 	if (force_refresh === true) {
	// 		ajax_refresh = true;
	// 	}

	// 	// only reload from server if the div is not already populated.
	// 	if (ajax_refresh === true) {
	// 		$div.html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading shore excursions...');

	// 		Adzuki.Ajax.get(ajax_url)
	// 			.then(function _showExcursions(html) {
	// 				$div.html(html);
	// 				$input.data("populated", 1);
	// 		});

	// 		$div.on('click', '.port-link', function scrollTo(e) {
	// 			var el = $(this).attr('href');

	// 			e.preventDefault();

	// 			$('html, body').animate({
	// 			    scrollTop: ($(el).offset().top)
	// 			}, 500);

	// 		});

	// 		// show modal for excursion information
	// 		$div.on('click', '.excursion-modal', function showModal(e) {
	// 			var $self   = $(this),
	// 			    content = $self.find(".content").html(),
	// 			    title   = $self.data("title"),
	// 			    $modal  = $('.modal');

	// 			e.preventDefault();

	// 			$modal.find('.modal-body').html(content);
	// 			$modal.find('.modal-title').text(title);

	// 			$modal.modal();
	// 		});
	// 	}
	// }

	/**
	 * Load google map for property location
	 */
	function loadGoogleMap()
	{
		var $results_map = $(".aic-map"),
			data         = '',
			results_map  = '';

		if ($results_map.length > 0) {
			data        = $results_map.data('results');
			results_map = new Adzuki.Map('.aic-map', {zoom: 13});

			setTimeout(function showTheMap() {
				results_map.populate(data.map);
			}, 1100);
		}
	}

	function onViewPolicyClick(event)
	{
		_openModal($(this), event);
	}

	function onViewQuoteClick(event)
	{
		_openModal($(this), event);
	}

	function _openModal($elem, event)
	{
		var modal_title   = $elem.data('modal-title');
		var iframe_src    = $elem.data('iframe-src');
		var iframe_height = $elem.data('iframe-height') || 500;
		var iframe_width  = $elem.data('iframe-width') || '100%';
		var $modal        = $('.modal');

		event.preventDefault();

		$modal.addClass('wide');

		$modal.find('iframe').attr({
			src   : iframe_src,
			height: iframe_height,
			width : iframe_width
		});

		$modal.find('.modal-dialog').addClass('modal-lg');
		$modal.find('.modal-title').text(modal_title);
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.find('iframe').attr({
				src: ''
			});
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	}

	Adzuki.Web.MyTrips = MyTrips;
}(jQuery, window.Adzuki || {}));
